import { styled } from 'styled-components';

export const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Quote = styled.blockquote`
  font-style: italic;
  margin-bottom: 0.1rem;
  text-align: justify;
  font-size: 1.1rem;
  line-height: 2rem;
`;
